import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { Physical } from '../../canvas/entities/Physical';
import { TransformButton } from '../../canvas/tooling/transform/TransformButton';
import { AttachPhysical } from '../../canvas/visualization/AttachPhysical';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { InlineWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const FinishFrame = styled.div`
    & > * {
        position: absolute;
        bottom: 0;
        right: 0;
        transform: translate(50%, 50%);
    }
`;

export const ActiveSketchWidget = ({ widget }: { widget: InlineWidget }) => {

    const subject = widget.subject as Physical;
    useComponentObserver(subject);

    const onFinish = () => {
        widget?.onAction();

    };

    if (!subject?.alive) return null;

    return <AttachPhysical object={subject}>
        <Flexer absolute inset="-4" flex border={`solid .125rem ${Colors.primaryLight}`}>
            <FinishFrame>
                <TransformButton onClick={onFinish}>
                    <Icon size="1.25" src="deqo://icons/hero/check" />
                </TransformButton>
            </FinishFrame>
        </Flexer>
    </AttachPhysical>;
};
